import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { Loader2 } from 'lucide-react';

export function AuthCallback() {
    const { instance } = useMsal();
    const navigate = useNavigate();

    useEffect(() => {
        const handleRedirect = async () => {
            try {
                const response = await instance.handleRedirectPromise();
                if (response) {
                    // Successfully logged in via redirect
                    navigate('/dashboard', { replace: true });
                } else {
                    // No response means user navigated here directly
                    navigate('/login', { replace: true });
                }
            } catch (error) {
                console.error('Auth callback error:', error);
                navigate('/login', { replace: true });
            }
        };

        handleRedirect();
    }, [instance, navigate]);

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-[var(--color-bg)]">
            <Loader2 className="w-8 h-8 animate-spin text-[var(--color-primary)] mb-4" />
            <p className="text-[var(--color-text-secondary)]">Authentification en cours...</p>
        </div>
    );
}
